import PropTypes from 'prop-types'

import { TelematicDeviceAccessoryTypes } from '../../models/vehicle/telematic-device-accessory-type-enum.js'
import { iso8601PropType } from '../common/iso-8601-prop-type'

/**
 * @typedef {Object} TelematicDeviceAccessory
 * @property {boolean} connected
 * @property {iso8601} lastConnectTime
 * @property {iso8601} lastDisconnectTime
 * @property {string} telematicDeviceAccessoryIdentifierName
 * @property {string} telematicDeviceAccessoryType
 */

const telematicDeviceAccessoryPropType = PropTypes.shape({
    connected: PropTypes.bool,
    lastConnectTime: iso8601PropType,
    lastDisconnectTime: iso8601PropType,
    telematicDeviceAccessoryIdentifierName: PropTypes.string,
    telematicDeviceAccessoryType: PropTypes.oneOf(Object.values(TelematicDeviceAccessoryTypes))
})

export { telematicDeviceAccessoryPropType }
